import React from 'react'
import Section from '../components/Section'
import Press1 from '../assets/images/as-seen-in/artisan-alliance.png'
import Press2 from '../assets/images/as-seen-in/built-in-austin.png'
import Press3 from '../assets/images/as-seen-in/business-with-purpose.jpg'
import Press4 from '../assets/images/as-seen-in/conscious-lifestyle-magazine.png'
import Press5 from '../assets/images/as-seen-in/female-founder-collective.png'
import Press6 from '../assets/images/as-seen-in/mochni.jpg'
import Press7 from '../assets/images/as-seen-in/mogul.jpg'
import Press8 from '../assets/images/as-seen-in/selva-beat.jpg'
import Press9 from '../assets/images/as-seen-in/social-good-podcast.png'
import Press10 from '../assets/images/as-seen-in/tribeza.jpg'
import Award1 from '../assets/images/as-seen-in/mogul-award.png'
import Award2 from '../assets/images/as-seen-in/mogul-award2.png'
import Certification1 from '../assets/images/as-seen-in/ffc.png'
import Certification2 from '../assets/images/as-seen-in/pending-b-corp.png'

function Template() {
	return (
		<div className='main-container'>
			<Section className='height-auto'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-sm-8 col-md-7 text-center'>
							<h2>As Seen In</h2>
							<p className=''>
								Lorem ipsum dolor sit amet consectetur
								adipisicing elit. Maxime dolorum suscipit
								asperiores placeat accusantium rerum animi
								consequuntur sed optio inventore!
							</p>
						</div>
					</div>
				</div>
			</Section>

			<Section id='press__section'>
				<div className='col-12'>
					<h3>Certifications</h3>
					<hr />
					<a
						href='https://www.femalefoundercollective.com/'
						target='_blank'
						rel='noopener noreferrer'>
						<img
							src={Certification1}
							alt='Female Founders Collective Certification'
						/>
					</a>
					<a
						href='https://bcorporation.net/about-b-corps'
						target='_blank'
						rel='noopener noreferrer'>
						<img src={Certification2} alt='Pending B Corp Award' />
					</a>
				</div>
				<div className='col-12'>
					<h3>Awards</h3>
					<hr />
					<a
						href='https://onmogul.com/stories/mogul-announces-the-top-1000-companies-worldwide-for-millennial-women-in-2018-f48b6994-140e-446b-abe4-faf2de283340'
						target='_blank'
						rel='noopener noreferrer'>
						<img src={Award1} alt='Mogul Award' />
					</a>
					<a
						href='https://onmogul.com/stories/mogul-s-top-1000-companies-with-the-strongest-female-leaders-in-2018'
						target='_blank'
						rel='noopener noreferrer'>
						<img src={Award2} alt='Mogul Award' />
					</a>
				</div>
				<div className='col-12'>
					<h3>Press</h3>
					<hr />
					<a
						href='https://www.builtinaustin.com/2018/01/15/austin-women-led-startups-2018'
						target='_blank'
						rel='noopener noreferrer'>
						<img src={Press2} alt='Builtin Austin Logo' />
					</a>
					<a
						href='https://www.stillbeingmolly.com/2018/09/26/business-purpose-podcast-sydney-sherman-faire/'
						target='_blank'
						rel='noopener noreferrer'>
						<img src={Press3} alt='Business With Purpose Logo' />
					</a>
					<a
						href='https://www.consciouslifestylemag.com/faire-shop/'
						target='_blank'
						rel='noopener noreferrer'>
						<img src={Press4} alt='Conscious Lifestye Logo' />
					</a>
					<a
						href='https://www.femalefoundercollective.com/'
						target='_blank'
						rel='noopener noreferrer'>
						<img
							src={Press5}
							alt='Female Founder Collective Logo'
						/>
					</a>
					<a
						href='https://www.mochni.com/ethical-brand-guide/ethical-online-retailers/#1549636685631-85c8fd17-f806'
						target='_blank'
						rel='noopener noreferrer'>
						<img src={Press6} alt='Mochni Logo' />
					</a>
					<a
						href='https://onmogul.com/stories/mogul-announces-the-top-1000-companies-worldwide-for-millennial-women-in-2018-f48b6994-140e-446b-abe4-faf2de283340'
						target='_blank'
						rel='noopener noreferrer'>
						<img src={Press7} alt='Mogul Logo' />
					</a>
					<a
						href='https://www.selvabeat.com/home/self-love'
						target='_blank'
						rel='noopener noreferrer'>
						<img src={Press8} alt='Selva Beat Logo' />
					</a>
					<a
						href='https://www.iheart.com/podcast/263-social-good-podcast-29037897/episode/sidney-sherman-faire-shop-30019287/'
						target='_blank'
						rel='noopener noreferrer'>
						<img src={Press9} alt='Social Good Podcast Logo' />
					</a>
					<a
						href='https://tribeza.com/tribeza-talk-september-2018/'
						target='_blank'
						rel='noopener noreferrer'>
						<img src={Press10} alt='Tribeza Logo' />
					</a>
					<a
						href='http://www.artisanalliance.org/member-network/'
						target='_blank'
						rel='noopener noreferrer'>
						<img src={Press1} alt='Artisan Alliance Logo' />
					</a>
				</div>
			</Section>
		</div>
	)
}

export default Template
